<!--专家达人-->
<template>
  <div>
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <!--面包屑-->
      <el-col :span="16">
        <div class="grid-content">
          <el-breadcrumb class='crumbs' separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
            <el-breadcrumb-item>活动列表</el-breadcrumb-item>
            <el-breadcrumb-item>活动详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
      <el-col :span="16">
        <!-- tabs选项卡-->
        <div class="grid-content1">
          <el-tabs :tab-position="tabPosition">
            <el-tab-pane label="专家达人">
              <h2>专家达人</h2>
              <ul class='content'>
                <a><li class='title'>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      class='img'
                      :src="url"
                      :fit="fit"></el-image>
                  </div>
                  <p>某某某</p>
                </li></a>
                <a><li class='title'>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      class='img'
                      :src="url"
                      :fit="fit"></el-image>
                  </div>
                  <p>某某某</p>
                </li></a>
                <a><li class='title'>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      class='img'
                      :src="url"
                      :fit="fit"></el-image>
                  </div>
                  <p>某某某</p>
                </li></a>
                <a><li class='title'>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      class='img'
                      :src="url"
                      :fit="fit"></el-image>
                  </div>
                  <p>某某某</p>
                </li></a>
                <a><li class='title'>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      class='img'
                      :src="url"
                      :fit="fit"></el-image>
                  </div>
                  <p>某某某</p>
                </li></a>
                <a><li class='title'>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      class='img'
                      :src="url"
                      :fit="fit"></el-image>
                  </div>
                  <p>某某某</p>
                </li></a>
              </ul>
              <!--分页-->
              <el-pagination
                class='pagination'
                small
                layout="prev, pager, next"
                :total="50">
              </el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fits: ['cover'],
      tabPosition: 'left',
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  padding-bottom: 20px;
  background-color: #eee;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  height: 50px;
  //面包屑
  .crumbs{
    line-height:50px;
    font-size: 16px;
    text-indent: 10px;
    background-color: #fff;
    margin-top: 20px;
  }
}
::v-deep .el-tabs__content{
  padding-bottom: 20px;
  background-color: #fff;
}
.grid-content1 {
  min-height: 100px;
  h2{
    height: 50px;
    width: 100%;
    background-color: #fff;
    font-size: 16px;
    font-family: "MicrosoftYaHei";
    font-weight: bold;
    line-height: 50px;
    padding-left: 15px;
    color: #333;
  }
  .content{
    padding: 0 15px;
    background-color: #fff;
    .title{
      width: 20%;
      display: block;
      float: left;
      p{
        width: 100%;
        text-align: center;
        height: 35px;
        line-height: 35px;
        display: block;
        color: #333;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
      }
    }
    .block{
      padding: 0 15px;
      height: 240px;
      .img{
        height: 240px;
      }
    }
  }
}
//分页
.pagination{
  width: 100%;
  margin-top: 15px;
  text-align: right;
  float: right;
}
//tabs选项卡
::v-deep .el-tabs{
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left{
  text-align: center;
  height:46px;
  width: 280px;
  font-family: Tahoma;
  font-size: 14px;
  color: #333;
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:hover{
  background-color: #11a84e;
  color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:focus{
  background-color: #11a84e;
  color: #fff;
}
// 默认选中的样式
::v-deep .el-tabs--left .el-tabs__item.is-active {
  background-color: #11a84e;
  color: #fff;
}
</style>
